'use client';

import { ErrorBox } from 'components/common/error-box.tsx';

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ExternalError(props: Props) {
  return <ErrorBox {...props} />;
}
